// extracted by mini-css-extract-plugin
export var active = "_lq-2";
export var recordingDot = "_lq-1";
export var recordingIndicator = "_lq-0";